import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Importamos el hook `useNavigate`
import { useForm } from "react-hook-form";
import { Image } from 'react-bootstrap';
import environment from '../../environment/environment';
import { useUser} from '../../context/UserContext';
import { getUserWithAuthorities } from "../../services/users/usersService";

import { login } from '../../services/auth/authService';

const Login = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { setUser } = useUser();

  const backgroundImage = "url('/assets/images/backgrounds/Login.jpg')";
  const navigate = useNavigate(); // Creamos la función `navigate` para manejar la navegación

  const { register, handleSubmit, formState: {errors} } = useForm({
    defaultValues: {
      email: '',
      password: ''
    }
  });

  useEffect(() => {
    if (localStorage.getItem('user-jwt'))
      navigate('/sensors'); // Redirige a la vista de sensores si ya está logueado
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((status) => !status);
  };

  const onSubmit = async (data) => {
    const body = {
      email: data.email.trim().toLowerCase(),
      password: data.password
    };

    try {
      const loginResponse = await login(body);
      localStorage.setItem('user-jwt', loginResponse.token);
      
      // Si el login es exitoso, obtener datos del usuario
      const user = await getUserWithAuthorities();

       // Guardar usuario en el contexto
      setUser(user);
      navigate('/sensors');
    } catch (error) {
      console.error('Datos erróneos o formulario mal diligenciado: ', error);
      alert("Datos erróneos o formulario mal diligenciado, por favor, intenta de nuevo.");
    }
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: backgroundImage }}>
      <div className="flex flex-col-reverse md:flex-row w-full max-w-5xl rounded overflow-hidden shadow-lg px-4">
        <div className="flex-col items-center w-full md:w-3/5 rounded-b-2xl md:rounded-none md:rounded-l-2xl p-10 bg-[rgba(255,255,255,0.85)] shadow-lg">
          <a href={`${environment.websiteUrl}`} target="_blank" rel="noopener noreferrer">
            <Image width={815} height={624} src={environment.logo} alt="VIT Sensors logo" className='mx-auto mb-4 h-24 w-auto' />
          </a>

          <h1 className="text-center text-3xl font-bold mb-4">Bienvenido a Agroup</h1>

          {/* <hr className='my-4 border-t border-[#136caf]'/> */}

          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col items-center space-y-3 pb-2">
            <div className='w-full relative'>
              <label htmlFor="email" className="block font-semibold text-black mb-1"> Email <span className="text-red-500">*</span></label>
              <input id="email" type="email" autoComplete="email"
                name="email"
                placeholder="Email"
                className="block w-full p-2 bg-gray-50 border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                {...register("email",{
                  required: {
                    value: true,
                    message: 'Email es requerido'
                  }    
                })}
              />
              {errors.email && (
                <span className="error">{errors.email.message}</span>
              )}
            </div>

            <div className='w-full relative'>
              <label htmlFor="password" className="block font-semibold text-black mb-1"> Contraseña <span className="text-red-500">*</span></label>
              <input id="password" type={isPasswordVisible ? "text" : "password"} autoComplete="off"
                name="password"
                placeholder="Contraseña"
                className="block w-full p-2 bg-gray-50 border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                {...register("password", {
                  required: "La contraseña es requerida",
                  minLength: {
                    value: 6,
                    message: "La contraseña debe tener al menos 6 caracteres"
                  }
                })}
              />
              {errors.password && (
                <span className="absolute error">{errors.password.message}</span>
              )}

              <button type="button" onClick={togglePasswordVisibility} className="absolute flex items-center inset-y-0 right-0 px-3 mt-8">
                <span className="material-icons text-blue-600">{isPasswordVisible ? 'visibility_off' : 'visibility'}</span>
              </button>
            </div>

            <div className="flex items-center justify-center space-x-4 mt-4">
              <div className="w-full">
                <button type="submit" className="flex flex-1 rounded w-full justify-center text-white bg-blue-600 hover:bg-blue-800 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200 disabled:bg-blue-400 disabled:opacity-50">
                  Iniciar sesión
                </button>
              </div>
            </div>

            <div className='flex flex-col items-center text-center mt-4 text-sm text-black'>
              <span>Si olvidaste tu contraseña, contáctanos al correo:</span>
              <a href={`mailto:${environment.emailContact}`} className="hover:text-blue-600 hover:font-semibold overflow-wrap break-words">{environment.emailContact}</a>
            </div>
          </form>

          <div className="flex flex-wrap justify-center space-x-2 pt-4">
            <a href="https://www.facebook.com/VITSensors" target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/Facebook.png" alt="Facebook" style={{ width: '35px', height: 'auto' }} />
            </a>
    
            <a href="https://www.instagram.com/vitsensors" target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/Instagram.png" alt="Instagram" style={{ width: '35px', height: 'auto' }} />
            </a>
    
            <a href="https://www.youtube.com/@vitsensors5408" target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/YouTube.png" alt="YouTube" style={{ width: '35px', height: 'auto' }} />
            </a>
    
            <a href="https://www.x.com/VITSensors" target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/X.png" alt="X (Twitter)" style={{ width: '35px', height: 'auto' }} />
            </a>
    
            <a href="https://www.linkedin.com/company/vit-sensors" target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/LinkedIn.png" alt="LinkedIn" style={{ width: '35px', height: 'auto' }} />
            </a>
    
            {/* <a href="https://www.tiktok.com/@cuenta_de_vit_sensors" target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/TikTok.png" alt="TikTok" style={{ width: '35px', height: 'auto' }} />
            </a> */}
    
            <a href={`https://wa.me/${environment.whatsAppContact}`} target="_blank" rel="noopener noreferrer">
              <Image width={48} height={48} src="/assets/images/social media/WhatsApp.png" alt="WhatsApp" style={{ width: '35px', height: 'auto' }} />
            </a>
          </div>
        </div>

        <div className="flex-col items-center w-full md:w-2/5 rounded-t-2xl md:rounded-none md:rounded-r-2xl p-4 bg-[#136caf] text-white text-center shadow-lg">
          <h2 className="text-2xl font-bold md:mt-60">¡Bienvenido/a!</h2>
          <p>¡Si lo puedes medir, lo puedes controlar y optimizar!</p>
        </div>
      </div>
    </div>
    // <div className="flex items-center justify-center min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: backgroundImage }}>
    //   <div className="flex flex-row md:flex-col w-full max-w-3xl rounded overflow-hidden shadow-lg">
        
    //   </div>
    // </div>


  );
};

export default Login;